import { getAnalyticsPagesMap } from '@whitbread-eos/api';
import analytics from './analytics';
export var formatAnalyticsFunnelStep = (siteType, page, language) => {
  var countryByLanguage = (language === null || language === void 0 ? void 0 : language.toLocaleLowerCase()) === 'de' ? 'DE' : 'UK';
  var formattedSiteType = siteType === 'PIB' ? 'PB' : siteType;
  return "Web:".concat(formattedSiteType, ":").concat(countryByLanguage, ":").concat(page);
};
export default function setPageAnalytics(pathName, siteType, queryParams, language) {
  var pagesMap = getAnalyticsPagesMap(siteType);
  var pageDetails = pagesMap.find(pageDetails => pathName.includes(pageDetails.pathMatch));
  if (!pageDetails) return;
  var page = pageDetails.page === 'HDP' && !queryParams.NIGHTS ? 'DLP' : pageDetails.page;
  var funnelStep = formatAnalyticsFunnelStep(siteType, page, language);
  analytics.update({
    pageName: page === 'AddToWallet' && language === 'de' ? 'Web:PI:DE:QR Add to Wallet Apple' : pageDetails.pageName,
    pageType: pageDetails.pageType,
    siteType: siteType,
    funnel_step: funnelStep
  });
}